import { defineStore } from 'pinia'
import { computed, ref, watch } from 'vue'
import { CustomerConfiguration } from '../src/configuration/CustomerConfiguration'
import { useAuthStore } from './authStore'
import { useLogger } from '../composables/useLogger'

export const useConfigStore = defineStore('config', () => {
    const userConfiguration = ref<CustomerConfiguration | null>(null)
    const logger = useLogger()

    const authStore = useAuthStore()
    const userId = computed(() => authStore.userId)

    watch(userId, () => {
        logger.debug('useConfigStore: userId changed, resetting store', { userId: userId.value })
        $reset()
        loadCustomerConfiguration()
    })

    function $reset() {
        logger.debug('useConfigStore: $reset', { userId: userId.value })
        userConfiguration.value = null
    }

    async function loadCustomerConfiguration(): Promise<void> {
        logger.debug('useConfigStore: loadCustomerConfiguration', { userId: userId.value })
        if (!userId.value) {
            logger.debug('useConfigStore: No userId, skipping loadCustomerConfiguration')
            return
        }
        userConfiguration.value = await CustomerConfiguration.getFromDatabase()        
    }

    loadCustomerConfiguration()

    async function updateValue(key: string, value: any): Promise<void> {
        if (userConfiguration.value) {
            userConfiguration.value.set(key, value)
            await userConfiguration.value.saveToDatabase()
        }
    }

    

    return {
        userConfiguration: userConfiguration,
        updateValue,
        loadCustomerConfiguration
    }
})